import { render } from "./budgetexpenses-modal.vue?vue&type=template&id=158849b2"
import script from "./budgetexpenses-modal.vue?vue&type=script&lang=js"
export * from "./budgetexpenses-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__